/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_FinancingInputs */

const cs_requirements_financing = /** @type {(inputs: Requirements_FinancingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financování`)
};

const en_requirements_financing = /** @type {(inputs: Requirements_FinancingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financing`)
};

/**
* | output |
* | --- |
* | "Financing" |
*
* @param {Requirements_FinancingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_financing = /** @type {((inputs?: Requirements_FinancingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_FinancingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_financing(inputs)
	return cs_requirements_financing(inputs)
});